/**
 * Author: Robert Banziziki Muhire
 * Date: 31/07/2020
 */
import logger from "loglevel";
import { ENVS } from "../config/config.interface";

const logDebug = (
  appModule: string,
  origin: string,
  type: "params" | "return" | "emit",
  data: unknown
) => {
  logger.debug(
    `%c DEBUG:%c ${appModule} - %c ${origin} %c ${type}: `,
    "color:white; font-weight:bold; background-color: #D72638",
    "color:white; font-weight:bold; background-color: #1D1A05",
    "color:black; font-weight:bold; background-color: #7fb069",
    `color:white; background-color: ${type === "params" ? "#0d3b66" : type === "return" ? "#ee964b" : "yellow"
    }`,
    data
  );
};

function setLogLevel(env:ENVS ){
switch (env) {
  case "production":
    logger.setLevel("WARN");
    break;
  case "staging":
    logger.setLevel("INFO");
    break;
  case "test":
    logger.setLevel("TRACE");
    break;
  case "develop":
    logger.setLevel("WARN");
    break;
  default:
    logger.setLevel("WARN");
    break;
}
}

export { logger, logDebug, setLogLevel };
